module.exports = __webpack_public_path__ + "static/media/IOTX-BUSD.4cac6180.svg";